<template>
  <div class="form-fields">
    <div v-for="field in fields" :key="field.value" class="field field-container">
      <phone-number-input
        v-if="field.isPhoneWithCountryField"
        :ref="field.value"
        :id="field.value"
        :name="field.value"
        :value="field.initialValue"
        :error="displayError(error, field.value)"
        @keyup.native.enter="handleSubmit"
        @input="handleCustomEvent(field.value, $event)"
        @input.native="handleChangeField">
      </phone-number-input>
      <b-field
        v-else
        :label="field.label"
        :label-for="field.value"
        :type="checkType(error, field.value)"
        :message="displayError(error, field.value)"
      >
        <password-field
          v-if="field.isPassword"
          :ref="field.value"
          :id="field.value"
          :name="field.value"
          :value="field.initialValue"
          @keyup.native.enter="handleSubmit"
          @input.native="handleChangeField">
        </password-field>
        <phone-verification-field
          v-else-if="field.isPhoneVerification"
          :ref="field.value"
          :id="field.value"
          :name="field.value"
          :value="field.initialValue"
          :phone-number="field.phoneNumber"
          @keyup.native.enter="handleSubmit"
          @input="handleCustomEvent(field.value, $event)">
        </phone-verification-field>
        <input-field
          v-else
          :ref="field.value"
          :id="field.value"
          :is-big="isBig"
          :name="field.value"
          :value="field.initialValue"
          :type="field.type"
          @keyup.native.enter="handleSubmit"
          @input.native="handleChangeField"
        ></input-field>
      </b-field>
      <slot :name="getAfterFieldSlotName(field.value)"></slot>
    </div>
  </div>
</template>

<script>

import {debounce} from 'lodash';

import errorsMixin from '../../source/mixins/errorsMixin';
import PhoneNumberInput from '../inputs/PhoneNumberInput';
import InputField from './InputField';
import PasswordField from './PasswordField';
import PhoneVerificationField from './PhoneVerificationField';

export default {
  mixins: [errorsMixin],
  props: {
    fields: Array,
    error: Object,
    isBig: Boolean
  },
  methods: {
    getAfterFieldSlotName(fieldName) {
      return `after-field-${fieldName}`;
    },
    handleSubmit() {
      this.$emit('on-submit');
    },
    handleCustomEvent(fieldName, value) {
      this.handleChangeField({target: {name: fieldName, value}});
    },
    handleChangeField: debounce(function(e) {
      this.$emit('on-change-field', e);
    }, 100)
  },
  components: {PasswordField, PhoneNumberInput, PhoneVerificationField, InputField}
};
</script>
